import { getI18nMessage } from '../../api/api'
import i18n from '@/Language';
import { getAllSysDictType, getCountryTimeZoneList } from '../../api/org'
import { getRegionChildren } from '../../api/api'
import TranslationDB from "@/Language/i18nDB"
import _ from 'lodash'

const dictStorage = window.localStorage.getItem('dict');
const dictObjStorage = window.localStorage.getItem('dictObj');
const specialTreatmentDicts = ['roleStatus', 'menuVisableStatus', 'InstallationPlan', 'accessPlatform', 'PlantCategory', 'GridConnectionMode'] // 特殊调整字段code为Number类型（质保金字段）
const countryMapStorage = window.localStorage.getItem('countryMap');

const dict = {
  state: {
    dict:  dictStorage ? JSON.parse(dictStorage) : {},
		dictObj: dictObjStorage ? JSON.parse(dictObjStorage) : {},
    dictRequested: false,
    countryMap: countryMapStorage ? JSON.parse(countryMapStorage) : {}
  },
  mutations: {
    SET_DICT: (state, arr) => {
      state.dict = arr
      window.localStorage.setItem('dict', JSON.stringify(arr))
			const dictObj = {}
			Object.keys(arr).forEach(item => {
				dictObj[item] = {}
				arr[item].forEach(i => {
					dictObj[item][i.dictValue] = i.dictCode
				})
			})
			state.dictObj = dictObj
			window.localStorage.setItem('dictObj', JSON.stringify(dictObj))
      state.dictRequested = true
    },
    SET_LANGUAGE: (state, obj) => {
      // i18n.setLocaleMessage(obj.language, obj.data)
      i18n.mergeLocaleMessage(obj.language, obj.data)
      // 待合并语言结束后，保存到本地数据库中，下次直接读取即可，无需再次请求接口获取数据
      if (obj.i18nDB) {
        // 保存到本地数据库中，下次直接读取即可，无需再次请求接口获取数据
        obj.i18nDB.saveTranslations(obj.language, obj.data).then(res => {
          console.log('多语言保存到本地数据库中')
        }).catch(err => {
          console.log('多语言保存到本地数据库中失败', err)
        })
      }
    },
    SET_COUNTRY_MAP: (state, obj) => {
      state.countryMap = obj
      window.localStorage.setItem('countryMap', JSON.stringify(obj))
    }
  },
  actions: {
    setDict({ commit, state, dispatch }, arr = null) {
      const dictPromise = getAllSysDictType().catch(() => ({ success: false }));
      const regionPromise = getRegionChildren().catch(() => ({ success: false }));

      Promise.all([
        dictPromise,
        regionPromise
      ]).then(([dictRes, regionRes]) => {
        let arr = {};
        
        // 处理字典数据
        if (dictRes && typeof dictRes === 'object' && dictRes.success) {
          arr = dictRes.data || {};
          // 特殊处理数组code，字段类型为字符串改为Number
          if (specialTreatmentDicts.length && arr) {
            specialTreatmentDicts.forEach(item => {
              arr[item] = arr[item]?.map(i => {
                i.dictValue = Number(i.dictValue)
                return i
              })
            })
          }
        }
        
        // 处理国家列表，转换为字典格式
        if (regionRes && typeof regionRes === 'object' && regionRes.success && regionRes.data) {
          arr.countrySelect = regionRes.data.map(item => ({
            dictValue: String(item.id),
            dictCode: item.name
          }));
        }
        
        if (Object.keys(arr).length) {
          commit('SET_DICT', arr);
        } else {
          this.dictRequested = true;
        }
      }).catch(() => {
        state.dictRequested = true;
        console.log('获取字典或国家列表失败');
      });
      
      // getCountryTimeZoneList 逻辑保持不变，独立执行
      getCountryTimeZoneList().then((res) => {
        if (!res || typeof res !== 'object') return;
        const { success, data } = res;
        if (success && Array.isArray(data)) {
          dispatch('setCountryMap', data);
        }
      })
		},
    setLanguage({ commit }, language = 'en-US') {
      const i18nDB = new TranslationDB()
      getI18nMessage({ language }).then(res=> {
        if (!res || typeof res !== 'object') return;
        const { success, data } = res
        if (success && !_.isEmpty(data)) {
          commit('SET_LANGUAGE', { language, data, i18nDB })
          // window.localStorage.setItem(language, JSON.stringify(data))
        } else {
          try {
            // const data =  JSON.parse(window.localStorage.getItem(language))
            // data && commit('SET_LANGUAGE', { language, data })
            i18nDB.getTranslations(language).then(data => {
              !_.isEmpty(data) && commit('SET_LANGUAGE', { language, data })
            })
          } catch(e) {
            console.log('获取国际化失败', e)
          }
        }
      }).catch(err => {
        try {
          // const data =  JSON.parse(window.localStorage.getItem(language))
          // data && commit('SET_LANGUAGE', { language, data })
          i18nDB.getTranslations(language).then(data => {
            !_.isEmpty(data) && commit('SET_LANGUAGE', { language, data })
          })
        } catch(e) {
          console.log('获取国际化失败err', err)
        }
      })
    },
    setCountryMap({ commit }, countryList = []) {
      // 将国家时区数组转换为 { [name]: "UTC+x" } 格式
      const countryMap = {};
      countryList.forEach(item => {
        if (!item || item.name == null) return;
        const offset = Number(item.timeZone);
        if (!isNaN(offset)) {
          const sign = offset >= 0 ? "+" : "-";
          countryMap[item.name] = offset === 0 ? "UTC" + offset : "UTC" + sign + Math.abs(offset);
        }
      });
      commit('SET_COUNTRY_MAP', countryMap)
    }
  }
}

export default dict